<template>
	<div id="offers-table">
		<table class="table" :aria-label="ariaLabel">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in headers"
						@click="orderByHeader(header, index)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="data.length > 0">
					<tr
						v-for="(row, index) in data"
						:key="row.id"
						:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
					>
						<td v-for="(item, index) in keys()" :key="index">
							{{ row[item] }}
						</td>
						<td class="actions" v-if="Object.keys(actions).length > 0">
							<div
								v-for="(actionName, key) of Object.keys(actions)"
								:key="key"
								@click="emit(actionName, row)"
							>
								<Tooltip
									:informationText="actions[actionName].informationText"
									:actionIcon="actions[actionName].actionIcon"
								/>
							</div>
						</td>
					</tr>
				</template>
				<template v-else>
					<tr class="stripped">
						<td colspan="3">Não há registros para serem exibidos</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
import Tooltip from '@/components/shared/Tooltip/Tooltip.vue';

export default {
	name: 'TableList',
	components: {
		Tooltip,
	},
	props: {
		data: {
			type: Array,
			required: true,
		},
		headers: {
			type: Array,
			required: true,
		},
		ariaLabel: {
			type: String,
			required: true,
		},
		actions: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	methods: {
		keys() {
			let keys = Object.keys(this.data[0]);
			const deleteIndex = keys.findIndex((key) => key === 'id');
			const hasId = deleteIndex !== -1;
			if (hasId) {
				keys.splice(deleteIndex, 1);
			}
			return keys;
		},
		emit(event, item) {
			this.$emit(event, item);
		},
	},
};
</script>
<style lang="scss" scoped>
@import './TableList.scss';
</style>
